import React, { Component } from "react";
import { Link } from 'react-router-dom';
import TimeSeriesChart from "../charts/TimeSeriesChart";
import RainChart from "../charts/RainChart";
import SvgIcon from "../SvgIcon";
import {  yyyymmdd, hhmmampm, formatGaugeAmount } from "../../helpers/gaugeHelpers";

class StreamReport extends Component {
    constructor ( props ) {
        super( props ); 

        this.setupReportResultsView = this.setupReportResultsView.bind(this);
        this.getCalculatedTotalsTable = this.getCalculatedTotalsTable.bind(this);
    }

    shouldComponentUpdate( nextProps, nextState ) {
        if( this.props.chartData.timeStamp !== nextProps.chartData.timeStamp  ) {
            //console.log("not the same");
            return true;
        }  

        
        return false
    }

    setupReportResultsView(data) {
        //console.log( this.props.showAlarms );
        
        return data.map( (gauge, key) => {
            let chart = null;
            let saveChartText = "Save, "+ gauge.stationName + ": " + gauge.gaugeType + ", to dashboard";
            switch( gauge.gaugeType ) {
                case "PRECIP":
                    chart = 
                    <RainChart  
                        uniqueID={`chart-${key}`} 
                        chartData={ gauge.chartData } 
                        graphHeight={500}  
                        saveChartToDashboard={this.props.saveChartToDashboard} 
                        type="report"
                        gaugeId={gauge.gaugeId}
                        saveChartText={ saveChartText }
                        canSaveCharts={ this.props.canAcccesStandardReports }
                        gaugeType={ gauge.gaugeType }
                        allowModeBar={true}
                    /> 
                    break;
                default:
                    chart = 
                    <TimeSeriesChart 
                        uniqueID={`chart-${key}`} 
                        chartData={ gauge.chartData } 
                        graphHeight={500}  
                        type="report" 
                        saveChartToDashboard={this.props.saveChartToDashboard} 
                        showAlarms={ this.props.showAlarms }
                        gaugeId={gauge.gaugeId}
                        saveChartText={ saveChartText }
                        canSaveCharts={ this.props.canAcccesStandardReports }
                        gaugeType={ gauge.gaugeType }
                        allowModeBar={true}
                    /> 
                    break;
            }

            //console.log(this.props.dateTimeSelections.dateTime.range);

            return (
                <div key={key} className="report-chart-result">
                    <h2>{gauge.chartTitle} from { this.formatFromToDate(this.props.dateTime.range.from) } to { this.formatFromToDate(this.props.dateTime.range.to)}</h2>
                    {chart}
                </div>
            )
        })
    }
    
    formatFromToDate(date){
        return `${yyyymmdd(date)} at ${hhmmampm(date)}` 
    }

    getCalculatedTotalsTable( summariezedData ){

        return (
            <div className="summariezed-data">
                <div className="responsive-table-wrap">
                    <table className="table-lined">
                        <thead>
                            <tr>
                                <td>Watershed</td>
                                <td>Station Name</td>
                                <td>Min WL (m)</td>
                                <td>Max WL (m)</td>
                                <td>Time of Max WL</td>
                                <td>Max RoC (m/15min)</td>
                                <td>Total WL Rise (m)</td>
                                <td>Alarms Triggered</td>
                                <td>Amount from Alarms</td>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                summariezedData.map( (data, index ) => {
                                    return (
                                        <tr key={index}>
                                            <td>{ data.watershed}</td>
                                            <td>{ data.station_name }</td>
                                            <td>{ data.min }</td>
                                            <td>{ data.max }</td>
                                            <td>{ yyyymmdd( new Date(data.datetime_of_max) )} { hhmmampm( new Date(data.datetime_of_max) ) }</td>
                                            <td>{ data.max_roc }</td>
                                            <td>{ data.total_rise }</td>
                                            <td>{ (data.alarm_triggered ? data.alarm_triggered : 'None') }</td>
                                            <td>{ formatGaugeAmount( data.amount_from_alarms, false, "WL" ) }</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        //console.log(this.props.chartData);
        var chart = null;
        if( this.props.chartData.report && this.props.chartData.report.charts ) {
            chart = this.setupReportResultsView(this.props.chartData.report.charts );
        }

        let dashboardLink = (this.props.canAcccesStandardReports) ?
        <a className="report-btn btn-link" onClick={ this.props.saveVisualizationToDashboard } ><SvgIcon icon="floppy-disk" /> Create a link to this report on your dashboard </a> : null;
        
        return(
            <div className="stream-report container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                    
                        { chart }

                        { this.getCalculatedTotalsTable( this.props.chartData.report.summariezedData) }

                        <div className="report-btn-container report-result-buttons">
                            <a 
                                className="report-btn btn-link"
                                href={ this.props.chartData.report.downloadCSV }
                            >   
                                <SvgIcon icon="download" /> Download Tabular Data
                            </a>

                            <Link className="report-btn btn-link" to={"/data-explorer"}><SvgIcon icon="download" /> Request Data</Link>

                            {dashboardLink}

                        </div>
                    </div>
                </div>  
            </div>
        );
    }
}

export default StreamReport;